module.exports = __webpack_public_path__ + "static/media/UsuarioDenegado.ded56579.png";